import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EmptyWidget from '../empty-widget';
import LoadingSpinner from '../../common/components/loading-spinner';
import UnverifiedSenders from './unverified-senders';

import {
    selectedUnverifiedSenderIdSelector,
    unverifiedSendersDataIsLoadingSelector,
    unverifiedSendersSelector,
} from './unverified-senders-selectors';
import { openUnverifiedSenderDetailsPane } from '../../common/actions/right-pane-action-creators';

import UNVERIFIED_SENDER_MESSAGES from './constants/unverified-sender-messages';

export class UnverifiedSendersContainer extends Component{
    handleOpenDetailsPane = ( senderId, senderName ) =>
        this.props.openUnverifiedSenderDetailsPane( senderId, senderName );

    render(){
        const {
            isLoading,
            selectedSenderId,
            senders
        } = this.props;

        if( isLoading ){
            return <LoadingSpinner />;
        }
        if( senders.length === 0 ){
            return <EmptyWidget text={UNVERIFIED_SENDER_MESSAGES.no_senders} type="unverified-senders"/>;
        }

        return (
            <UnverifiedSenders
                handleOpenDetailsPane={this.handleOpenDetailsPane}
                selectedSenderId={selectedSenderId}
                senders={senders}
            />
        );
    }
}

UnverifiedSendersContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    openUnverifiedSenderDetailsPane: PropTypes.func.isRequired,
    selectedSenderId: PropTypes.string.isRequired,
    senders: PropTypes.array,
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isLoading: unverifiedSendersDataIsLoadingSelector( state ),
        selectedSenderId: selectedUnverifiedSenderIdSelector( state ),
        senders: unverifiedSendersSelector( state ),
    };
};

const mapDispatchToProps = {
    openUnverifiedSenderDetailsPane
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( UnverifiedSendersContainer );
